/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_OutcodeInputs */



/**
* | output |
* | --- |
* | "Set Outcode (End)" |
*
* @param {Shortcut_Keys_Name_Set_OutcodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_outcode = /** @type {((inputs?: Shortcut_Keys_Name_Set_OutcodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_OutcodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Definir l'outcode (fin)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Outcode (Ende)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta codice di uscita (fine)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить исходящий код (Конец)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer código de salida (Fin)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置输出码（结束）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アウトコードの設定（終了）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटकोड सेट करें (समाप्त)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definir código de saída (Fim)")
	return /** @type {LocalizedString} */ ("Set Outcode (End)")
});